import { worklistNextWork } from '../features/command-center/pursuit/worklistNextWork.js'
import { recordedChampionFacts } from '../lib/recordedChampionFacts.js'
/** Text-only, safe inside cards/buttons/table cells; no new actions or reads. */
export default function RecordedChampion({ record, now = new Date(), showNext = true, displayedClaims = [], displayedMembers = [] }) {
  const facts = recordedChampionFacts(record)
  if (!facts.applicable) return null
  // Only omit exact claims already rendered by the adjoining detail view.
  // Distinct spellings/claims remain visible; this never changes record data.
  const claims = facts.claims.filter(claim => !displayedClaims.includes(claim))
  const members = facts.members.filter(member => !displayedMembers.includes(member))
  const empty = facts.claims.length === 0 && facts.members.length === 0
  const supplement = displayedClaims.length > 0 || displayedMembers.length > 0
  const work = showNext ? worklistNextWork(record, now) : null
  return <span data-recorded-champion style={{display:'block',whiteSpace:'normal',overflowWrap:'anywhere'}}>
    {(!supplement || claims.length > 0 || empty) && <><strong>Champion · recorded {claims.length ? 'claim' : 'names'}</strong>{' '}{claims.join(' · ') || (empty ? 'No champion name recorded' : '')}</>}
    {members.map((member,index) => <span key={index} style={{display:'block'}}>Member/reference: {member}</span>)}
    {(facts.claims.length > 0 || facts.members.length > 0) && <span style={{display:'block'}}>{facts.note}</span>}
    {work && <span data-recorded-next-work style={{display:'block'}}>Next work: {work.next}</span>}
    {facts.referencesError && <span style={{display:'block'}}>{facts.referencesError}</span>}
  </span>
}
